import { ArrowLeftRight, Shield } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useQueryParams } from '@valiant/ui-shared'

function ItemWrapper({
  isActive,
  onClick,
  icon,
  label,
}: {
  isActive: boolean
  onClick: () => void
  icon: React.ReactNode
  label: string
}) {
  return (
    <div
      className={`flex gap-2 md:px-2 md:py-1.5 md:shadow-md rounded-md cursor-pointer flex-wrap ${isActive ? 'bg-main md:bg-main md:text-white md:hover:bg-main' : ' md:hover:bg-main/10'}`}
      onClick={onClick}
    >
      <div
        className={`md:bg-main/10 text-main h-9.5 w-9.5 md:h-6 md:w-6 rounded-md flex items-center justify-center ${isActive ? 'text-white md:bg-white/80 md:text-main' : 'bg-main/10'}`}
      >
        {icon}
      </div>
      <div className="hidden md:block text-md">{label}</div>
    </div>
  )
}

function DashboardMode({
  isSwapMode,
  setIsSwapMode,
  clearSearchTerms,
}: {
  isSwapMode: boolean
  setIsSwapMode: (isSwapMode: boolean) => void
  clearSearchTerms: () => void
}) {
  const navigate = useNavigate()
  const { updateMultiple } = useQueryParams()

  const handleClick = (isSwapModeValue: boolean) => {
    if (isSwapModeValue === isSwapMode) return
    navigate('/')

    setIsSwapMode(isSwapModeValue)
    clearSearchTerms()
    updateMultiple({ dashboardMode: isSwapModeValue ? 'swap' : 'admin', tab: undefined })

    // Save to localStorage for persistence
    localStorage.setItem('dashboardMode', isSwapModeValue ? 'swap' : 'admin')
  }

  return (
    <div className="flex items-center gap-2 rounded-2xl md:bg-white md:p-2.5 md:shadow-xs">
      <ItemWrapper
        isActive={!isSwapMode}
        onClick={() => handleClick(false)}
        icon={<Shield className="h-4 w-4" />}
        label="Admin mode"
      />
      <ItemWrapper
        isActive={isSwapMode}
        onClick={() => handleClick(true)}
        icon={<ArrowLeftRight className="h-4 w-4" />}
        label="Swap mode"
      />
    </div>
  )
}

export { DashboardMode }
